<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div >
      <div
        class="container-fluid menu-component"
        style="width: 100%; height: auto"
      >
        <b-card class="bCardGlobal">
          <b-container fluid="">
            <b-row class="titulo">
              <b-col class="seccionTitulo">
                <!--<font-awesome-icon icon="f085" title="Soluciones"/>-->
                <em class="fa fa-money"></em>
                <span> Compensaciones</span>
              </b-col>
              <b-col class="seccionCodigo">
                <div>CO_01_comp</div>
              </b-col>
            </b-row>
          </b-container>

          <b-container fluid="">
            
            <b-row class="row-contenedor">
              <b-col>
                <b-tabs class="md-transparent borderGray">
                  <b-tab
                    v-if="mostrarBip && $localStorageService.can('C0_01_Com_BIP')"
                    lazy
                    active
                    id="tab-bip"
                    title="Bono Individual de Productividad"
                    class="borderGray paddingTab"
                  >
                    <Bip :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="$localStorageService.can('C0_01_Com_BRD')"
                    lazy
                    id="tab-bip"
                    title="Bonos Retenidos"
                    class="borderGray paddingTab"
                  >
                    <retenidos :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="$localStorageService.can('C0_01_Com_BRM')"
                    lazy
                    id="tab-brm"
                    title="Bono de Referenciación Mensual"
                    class="borderGray paddingTab"
                  >
                    <Brm :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="
                      aplicaComisionBloque &&
                      $localStorageService.can('Bloque_Pag_garantizado')
                    "
                    lazy
                    id="tab"
                    title="Reporte pago garantizado"
                    class="borderGray paddingTab"
                  >
                    <pago-garantizado :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="
                      aplicaComisionBloque &&
                      $localStorageService.can('Bloque_Pag_productividad')
                    "
                    lazy
                    id="tab"
                    title="BIP Bloque"
                    class="borderGray paddingTab"
                  >
                    <reporte-productividad :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="
                      aplicaComisionBloque &&
                      $localStorageService.can('Bloque_Pag_desempeno')
                    "
                    lazy
                    id="tab"
                    title="Reporte bono de desempeño"
                    class="borderGray paddingTab"
                  >
                    <pago-by-desempenio :empleados.sync="empleados" />
                  </b-tab>
                  <b-tab
                    v-if="
                      aplicaComisionBloque &&
                      $localStorageService.can('Bloque_Pag_recibo')
                    "
                    lazy
                    id="tab"
                    title="Recibo de bloques"
                    class="borderGray paddingTab"
                  >
                    <Pdb
                      :empleados.sync="empleados"
                      :aplicaBonoExtraordinario.sync="aplicaBonoExtraordinario"
                    />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";
import Bip from "../../components/Compensaciones/Bip.vue";
import Brm from "../../components/Compensaciones/Brm.vue";
import Pdb from "../../components/Compensaciones/Pdb.vue";
import retenidos from "@/components/Compensaciones/retenidos";
import PagoGarantizado from "@/components/Compensaciones/PagoGarantizado";
import PagoByDesempenio from "@/components/Compensaciones/PagoByDesempenio";
import ReporteProductividad from "@/components/Compensaciones/ReporteProductividad";

export default {
  name: "Tickets",
  components: {
    ReporteProductividad,
    PagoByDesempenio,
    PagoGarantizado,
    Header,
    Bip,
    Brm,
    Pdb,
    retenidos,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    spinner: false,
    busqueda: false,
    mostrarBip: true,
    filtroQuincena: null,
    aplicaBonoExtraordinario: true,
    aplicaComisionBloque: true,
    filtroMes: {
      fechaInicio: null,
      fechaFin: null,
      fechaInicioP: null,
      fechaFinP: null,
      quincena: null,
      busquedaMes: false,
    },
    filtro: {
      idClinica: null,
      idEmpleado: null,
      periodo: null,
      anio: null,
      mes: null,
      quincena: null,
    },
    empleados: [],
    idClinica: null,
    anios: [],
    meses: [
      { value: null, text: "Seleccionar mes" },
      { value: 1, text: "Enero" },
      { value: 2, text: "Febrero" },
      { value: 3, text: "Marzo" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Mayo" },
      { value: 6, text: "Junio" },
      { value: 7, text: "Julio" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Septiembre" },
      { value: 10, text: "Octubre" },
      { value: 11, text: "Noviembre" },
      { value: 12, text: "Diciembre" },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarAños();
    if (!this.$localStorageService.can("C0_01_Com_BIP")) {
      this.buscarChecks();
    }
    //this.filtro.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.buscarEmpleados();
  },
  watch: {
    "filtro.periodo": function (val) {
      if (val == 2) {
        this.filtro.quincena = null;
      }
    },
  },
  methods: {
    llenarAños() {
      let inicio = 2021;
      this.anios.push({ value: null, text: "Seleccionar año" });
      while (inicio <= new Date().getFullYear()) {
        this.anios.push(inicio);
        inicio++;
      }
    },
    actualizarFiltro(filtro) {
      this.filtro = filtro;
    },
    buscarEmpleados() {
      const params = {
        idClinica: this.idClinica
      }
      this.$http
        .post(this.$api + "colaboradores/clinica", params )
        .then((respuesta) => {
          if (
            respuesta.data.data.unshift({
              idEmpleado: null,
              nombreDoctor: "Seleccionar empleado",
            })
          ) {
            this.empleados = respuesta.data.data;
          }
        });
    },
    buscar() {
      this.spinner = true;
      this.busqueda = false;
      if (this.filtro.periodo === "1") {
        if (this.filtro.quincena === "1") {
          this.filtro.fechaInicio = new Date(
            this.filtro.anio,
            this.filtro.mes - 1,
            1,
            0,
            0,
            0,
            0
          );
          this.filtro.fechaFin = new Date(
            this.filtro.anio,
            this.filtro.mes - 1,
            15,
            23,
            59,
            59,
            0
          );
        } else {
          this.filtro.fechaInicio = new Date(
            this.filtro.anio,
            this.filtro.mes - 1,
            16,
            0,
            0,
            0,
            0
          );
          this.filtro.fechaFin = new Date(
            this.filtro.anio,
            this.filtro.mes,
            0,
            23,
            59,
            59,
            0
          );
        }
      } else {
        this.filtro.fechaInicio = new Date(
          this.filtro.anio,
          this.filtro.mes - 1,
          1,
          0,
          0,
          0,
          0
        );
        this.filtro.fechaFin = new Date(
          this.filtro.anio,
          this.filtro.mes,
          0,
          23,
          59,
          59,
          0
        );
      }

      this.filtroQuincena = {
        idClinica: this.idClinica,
        idEmpleado: this.filtro.idEmpleado,
        fechaInicio: this.$moment(this.filtro.fechaInicio)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaFin: this.$moment(this.filtro.fechaFin)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
      };

      this.filtroMes = {
        idClinica: this.idClinica,
        idEmpleado: this.filtro.idEmpleado,
        fechaInicio: this.$moment(this.filtro.fechaInicio)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaFin: this.$moment(this.filtro.fechaFin)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaInicioP: this.$moment(new Date(this.filtro.fechaInicio)).format(
          "L"
        ),
        fechaFinP: this.$moment(new Date(this.filtro.fechaFin)).format("L"),
        quincena: this.filtro.quincena,
      };

      setTimeout(() => {
        this.busqueda = true;
        this.spinner = false;
      }, 500);
    },

    buscarChecks() {
      this.filtro.idEmpleado = this.$localStorageService.getIdEmpleado();
      this.$http
        .post(
          this.$api + "comisiones/comision_bloque/empleado/pestanias",
          this.filtro
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            let datos = respuesta.data.data;
            this.aplicaComisionBloque = datos.horarioBloques;
            this.aplicaBonoExtraordinario = datos.bonoExtraordinario;

            this.mostrarBip = !this.aplicaComisionBloque;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
  },
};
</script>
